module.exports = __webpack_public_path__ + "vue/img/skk.2dfaff9c.png";